export default function GetFormattedDate(dateInInteger) {
  // console.log(dateInInteger, 'dateInInteger')
  let formattedDate = ''
  let formattedYear = ''
  let formattedMonth = ''
  let formattedDay = ''
  if (dateInInteger) {
    //
    formattedYear = dateInInteger.toString().substr(0, 4)
    if (dateInInteger.toString().length > 4) {
      formattedMonth = dateInInteger.toString().substr(4, 2)
      // formattedMonth = monthNames[parseInt(formattedMonth, 10) - 1]
    }

    if (dateInInteger.toString().length > 6) {
      formattedDay = dateInInteger.toString().substr(6, 2)
    }

    formattedDate = formattedYear + '-' + formattedMonth + '-' + formattedDay
  }

  // console.log(formattedDate, 'formattedDate121212')

  return formattedDate
}
